/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from "react";
import "../dashboard/Dashboard.css";
import { getAuth, useAuth } from "../../modules/auth";
import axios from "axios";
import io from "socket.io-client";
import {
  UserAttemptAccessNotification,
  accessNotificationToast,
} from "../../../_metronic/partials/notification-toast/notification-toast";
import { ListUsersLastAttemptsAccess } from "../dashboard/widget/ListUsersLastAttemptsAccess";

export interface LastAttemptAccess {
  origin_section: {
    created_at: Date;
    updated_at: Date;
    deleted_at: Date;
    _id: number;
    description: string;
  };
  destination_section: {
    created_at: Date;
    updated_at: Date;
    deleted_at: Date;
    _id: number;
    description: string;
  };
  entrance: {
    _id: number;
    description: string;
  };
  event_giveup: boolean;
  operation: {
    _id: number;
    description: string;
  };
  access: boolean;
  created_at: Date;
  user: {
    _id: number;
    email: string;
    first_name: string;
    last_name: string;
    profile_image: string;
    compliance: boolean;
    overdue: boolean;
    status: {
      _id: number;
      description: string;
    };
    bracelets: [
      {
        created_at: Date;
        updated_at: Date;
        deleted_at: Date;
        _id: number;
        _id_company: number;
        _id_bracelet_color: number;
        content: string;
        master: boolean;
        bracelet_color: {
          created_at: Date;
          updated_at: Date;
          deleted_at: Date;
          _id: number;
          name: string;
          color: string;
          visitors: boolean;
          status: {
            _id: number;
            description: string;
          };
        };
        access: {
          _id_user: number;
          latest_updated_at: Date;
          _id_bracelet: number;
          _id_destination_section: number;
        };
      }
    ];
  };
}

const Access: FC = () => {
  const [lastAttemptsAccess, setLastAttemptsAccess] = useState<
    LastAttemptAccess[]
  >([]);

  const [inputVisible2] = useState(true);
  const { currentUser } = useAuth();

  const loadDashboardData = async () => {
    const apiToken = getAuth();
    const token = apiToken?.api_token;
    const apiUrl = process.env.REACT_APP_API_URL;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    if (apiToken) {
      try {
        const response = await axios.get(`${apiUrl}/access/dashboard`, {
          headers,
        });

        return response.data;
      } catch (error) {
        console.error(error);
      }
    }
  };

  useEffect(() => {
    loadDashboardData().then((response) => {
      setLastAttemptsAccess(response?.lastAttemptsAccess);
    });

    const socket = io(process.env.REACT_APP_API_URL ?? "");

    const handleAttemptAccessNotification = (
      accessNotification: UserAttemptAccessNotification
    ) => {
      accessNotificationToast(accessNotification, true, false, false);

      loadDashboardData().then((response) => {
        setLastAttemptsAccess(response?.lastAttemptsAccess);
      });
    };

    const handleAccessNotification = (
      accessNotification: UserAttemptAccessNotification
    ) => {
      accessNotificationToast(accessNotification, false, true, false);

      loadDashboardData().then((response) => {
        setLastAttemptsAccess(response?.lastAttemptsAccess);
      });
    };

    const handleGiveUpAccessNotification = (
      accessNotification: UserAttemptAccessNotification
    ) => {
      accessNotificationToast(accessNotification, false, false, true);

      loadDashboardData().then((response) => {
        setLastAttemptsAccess(response?.lastAttemptsAccess);
      });
    };

    const handleVisitorCreationNotification = () => {
      loadDashboardData().then((response) => {
        setLastAttemptsAccess(response?.lastAttemptsAccess);
      });
    };

    const handleTopbarNotification = () => {
      loadDashboardData().then((response) => {
        setLastAttemptsAccess(response?.lastAttemptsAccess);
      });
    };

    socket.on(
      `attemptAccessNotification${currentUser?._id_company}`,
      handleAttemptAccessNotification
    );
    socket.on(
      `accessNotification${currentUser?._id_company}`,
      handleAccessNotification
    );
    socket.on(
      `giveUpAccessNotification${currentUser?._id_company}`,
      handleGiveUpAccessNotification
    );
    socket.on(
      `visitorCreationNotification${currentUser?._id_company}`,
      handleVisitorCreationNotification
    );
    socket.on(
      `topbarNotification${currentUser?._id_company}`,
      handleTopbarNotification
    );

    return () => {
      socket.off(
        `attemptAccessNotification${currentUser?._id_company}`,
        handleAttemptAccessNotification
      );
      socket.off(
        `accessNotification${currentUser?._id_company}`,
        handleAccessNotification
      );
      socket.off(
        `giveUpAccessNotification${currentUser?._id_company}`,
        handleGiveUpAccessNotification
      );
      socket.off(
        `visitorCreationNotification${currentUser?._id_company}`,
        handleVisitorCreationNotification
      );
      socket.off(
        `topbarNotification${currentUser?._id_company}`,
        handleTopbarNotification
      );

      socket.disconnect();
    };
  }, [currentUser]);

  return (
    <ListUsersLastAttemptsAccess
      lastAttemptsAccess={lastAttemptsAccess}
      inputVisible2={inputVisible2}
    />
  );
};

export { Access };
